import { Component, OnInit } from '@angular/core';
import { TipKomitenta } from './tip-komitenta';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-tip-komitenta-modal-update',
  templateUrl: './tip-komitenta-modal-update.component.html'
})
export class TipKomitentaModalUpdateComponent extends BaseModalUpdateComponent<TipKomitenta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipKomitenta>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
